import React, { Component } from 'react';
import { exportConversations } from '../../utility/conversation';
import { withRouter } from 'react-router';
import { withUser } from '../../utility/withUser';
import { connect } from 'react-redux';

/**
 * Component for showing export form.
 *
 * @extends React.Component
 */
class Export extends Component {
  /** @inheritdoc */
  constructor(props) {
    super(props);
    this.state = {
      startTime: null,
      endTime: null,
      status: null,
    }
  }

  /**
   * Handle when a tag group has been updated.
   */
  handleFieldChange = (field, e) => {
    var modifier = {};
    modifier[field] = e.target.value;
    this.setState(modifier);
  }

  /**
   * Handle clicking the export button.
   */
  handleClickExport = () => {
    exportConversations(this.state.startTime, this.state.endTime, this.state.status, this.props.token, this.props.history);
  }

  /** @inheritdoc */
  render() {
    return (
      <div className="tab-pane fade show active" id="export" role="tabpanel" aria-labelledby="export">
        <div className="widget">
          <h3 className="section-heading">Eksporter data</h3>
          <div className="form-group">
            <label htmlFor="name">Fra</label>
            <input type="datetime-local" className="form-control" id="startTime" value={this.state.startTime} onChange={(e) => {this.handleFieldChange('startTime', e);}} />
          </div>
          <div className="form-group">
            <label htmlFor="name">Til</label>
            <input type="datetime-local" className="form-control" id="endTime" value={this.state.endTime} onChange={(e) => {this.handleFieldChange('endTime', e);}} />
          </div>
          <div className="form-group">
            <label htmlFor="name">Samtaletype</label>
            <select type="text" className="form-control" id="status" value={this.state.status} onChange={(e) => {this.handleFieldChange('status', e);}}>
              <option value='_none'>Enhver</option>
              <option value='mine'>Mine</option>
              <option value='open'>Åbne</option>
              <option value='ongoing'>Igangværende</option>
              <option value='archive'>Arkiv</option>
            </select>
          </div>
          <button className="btn btn-primary" onClick={this.handleClickExport}>Eksporter data</button>
        </div>
      </div>
    );
  }
}

export default withRouter(withUser(connect()(Export)));



// WEBPACK FOOTER //
// ./src/components/Export/index.js